import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const ProductPageOdsDialogOnlineDoctorSectionTitle: FC = () => (
  <h2 className="mb-5 text-l">
    <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.heading" />
  </h2>
)
